<style lang='scss' scoped>
.sysorg {
	cursor: pointer;
	outline:none !important;
	display: flex;
	align-items: center;
	padding: 0 8px;
	border-radius: 8px;
	margin: 0 4px;
	transition: all 0.3s ease;
	
	&:hover {
		color: #00d4ff;
		background-color: rgba(0, 212, 255, 0.15);
		box-shadow: 0 0 15px rgba(0, 212, 255, 0.3);
		
		::v-deep .sysorg-icon {
			filter: drop-shadow(0 0 8px rgba(0, 212, 255, 0.8));
			transform: scale(1.1);
		}
	}
}
.sysorg-icon {
	font-size: 16px;
	margin-right: 6px;
	transition: all 0.3s ease;
	filter: drop-shadow(0 0 4px rgba(0, 212, 255, 0.5));
}
.sysorg-title{
	max-width: 180px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	text-shadow: 0 0 8px rgba(0, 212, 255, 0.4);
}
</style>


<template>
	<aside
		class="sysorg"
		tabindex='-1'
		v-show="organization.name"
		@click="open"
		@focusout="handleFocusOut"
	>
		<!-- 楼房图标 - 代表客户公司 -->
		<svg class="sysorg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
			<path d="M4 21V7L12 3L20 7V21H15V15H9V21H4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M12 3V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 12H10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M14 12H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M9 15H10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M14 15H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
		<span :title="organization.name" class="sysorg-title">{{organization.name}}&nbsp;</span>
		<transition appear name="move-up">
			<compSysList v-show="visible" />
		</transition>
	</aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import compSysList from './syslist';

export default {
	components: {
		compSysList
	},
	data() {
		return {
			visible: false
		};
	},
	methods: {
		handleFocusOut(){
			console.log(document.activeElement)
			clearTimeout(this.__timeout);
			this.__timeout = setTimeout(() => {
				if(!this.$el.contains(document.activeElement)) this.visible = false
			}, 400)
		},
		open() {
			clearTimeout(this.__timeout);
			this.visible = !this.visible;
		},
	},
	computed: {
		...mapState(['organization']),
	}
};
</script>
